import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ApiClient from '@/plugins/api-client'
import '@/assets/styles/index.scss'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import SearchForms from '@/components/searchComps/SearchForms.vue';
import CustomColumn from '@/components/CustomColumn.vue';
import AutoTooltip from '@/components/AutoTooltip.vue';
import dayjs from 'dayjs'

import {formatObjectToArray, filteredData, downloadFiles} from '@/utils/tools'
import {formatProfit} from '@/utils/toolsStats'

const app = createApp(App)

app.config.globalProperties.formatProductName = (value, list) => {
  return list.find(v=>v.value==value)?.label ?? value
}

// 全局方法挂载
app.config.globalProperties.$dayjs = dayjs
app.config.globalProperties.formatObjectToArray = formatObjectToArray
app.config.globalProperties.filteredData = filteredData
app.config.globalProperties.formatProfit = formatProfit
app.config.globalProperties.downloadFiles = downloadFiles

app.component('SearchForms', SearchForms)
app.component('CustomColumn', CustomColumn)
app.component('AutoTooltip', AutoTooltip);

app
.use(router).use(store).use(Antd)
.use(ApiClient)
.mount('#app')
